import { reactive, computed, onMounted, watch, onUnmounted, triggerRef } from 'vue';
import { useRouter } from 'vue-router'
import { useStore } from 'vuex';
import { POPUP, BTN, CONNECTION, THEME_OPT } from '@/enum/enum';
import Select from '../../../components/ui/select/index.vue';
import CircleChart from '../../../components/ui/circlechart/index.vue';
import Button from '../../../components/ui/button/index.vue';
import Linebar from '../../../components/ui/linebar/index.vue';
import iCon from '../../../components/ui/svgicon/index.vue';
import { apiGetDashboard, apiGetNotifications, apiGetTasks, apiGetGroupModel, apiSetNotification_approve, apiNotificationsCount } from '@/api/api';
import { dateTimeHandle } from '@/utils/time';
import { useI18n } from 'vue-i18n';
export default {
  components: {
    Select,
    CircleChart,
    Button,
    Linebar,
    iCon,
  },
  props: {
  },
  setup(props, { emit }) {//emit 傳到複層_emit('update:{function}', val)
    const { icon, isCheck } = props;
    const { t, locale } = useI18n();
    const multiLang = reactive({
      initRawData: {},
    })
    //data
    let state = reactive({

      groups_op: [], //list 
      groups: { // select
        text: t('__d7d_n17r.__allDevices'),
        val: 'All',
        isI18n: '__d7d_n17r.__allDevices',
      },
      group: "All",
      Connection: [],
      Calibration: [],
      // title_L: '__d7d_n17r.__amount',
      value_L_1: "",
      // name_L_1: '__d7d_n17r.__groups',
      value_L_2: "",
      // name_L_2: '__d7d_n17r.__devices',
      // title_R1: '__d7d_n17r.__task',
      // title_R2: '__d7d_n17r.__appointmentAmount',
      value_R_1: "",
      // name_R_1: '__d7d_n17r.__appointments',
      value_R_2: "",
      // name_R_2: '__d7d_n17r.__excutedTasks',
      line_chart_array: [],
      list_number: 0,
      list_data: [],
      page: 1,
      deviceListData: [],
      newNews: false, //是否秀出小紅點
      focusState: null,
    })
    const iconSrc = computed(() => {
      if (icon === '') return '';
      return icon.indexOf('http') > -1 ? icon : require(`@/assets/images/${icon}`)
    })
    const router = useRouter();
    const onClick = () => {
      router.push(`/${"main/dashboard/notification"}`);
    }
    const IsChecked = computed({
      get: () => isCheck,
      set: (val) => {
        emit('update:isCheck', val);
      }
    })


    const hasFocus = (i) => {
      state.focusState = i
    }

    const deviceListCol = computed(() => {
      return [
        {
          title: t('__g3p_m8t.__serialNumber'),
          key: "ssn",
          sort: true,
          isLink: true,
        },
        {
          title: t('__d7d_n17r.__pcName'),
          key: "host",
          sort: true,
        },
        {
          title: t('__d7d_n17r.__connectionStatus'),
          key: "device_status",
          sort: true,
          color: true,
          colorEnum:
          {
            0: CONNECTION[0],
            1: CONNECTION[1],
            2: CONNECTION[2],
          },
          isI18n:
          {
            0: '__g3p_m8t.__offline',
            1: '__g3p_m8t.__online',
            2: '__g3p_m8t.__waiting',
          },
        },
        {
          title: t('__d4e_m8t.__implementationStatus'),
          key: "newStatus",
          color: true,
          colorEnum:
          {
            999: CONNECTION[0],
            1: CONNECTION[1],
            2: CONNECTION[2],
            4: CONNECTION[1],
          },
          sort: true,
          isI18n:
          {
            999: '__common.__fail',
            1: '__common.__success',
            2: '__d7d_n17r.__waitingForReply',
            4: '__common.__successDeleted',
          },
        },
        {
          title: t('__d4e_m8t.__report'),
          key: "report",
          customRender: "report", //客製化slot，可用於外接其他組件
        },
      ]
    })


    const page_max = computed(() => {
      return Math.ceil(state.list_number / 6)
    })
    const click_page = (e) => {
      var _page;
      if (e == "+") {
        _page = state.page + 1
      } else if (e == "-") {
        _page = state.page - 1;
      }
      var max = page_max.value;
      if (_page >= 1 && _page <= max) {
        state.page = _page;
        getAPINotificationsData(state.page);
      }
    }
    const approve_click = async (e) => {
      try {
        var _data = {
          id: [
            e
          ],
          approve: true,
          type: "join"

        }
        await apiSetNotification_approve(_data);
        if (state.list_data.length - 1 <= 0) {
          state.page--
          if (state.page <= 1) {
            state.page = 1
          }
        }
        getAPINotificationsData(state.page);
      }
      catch (err) {
        console.log("apiSetNotification_approve", "err")
      }
    }
    const approve_click_all = async () => {
      try {
        var _id = [];
        state.list_data.forEach(element => _id.push(element.approve_id));
        var _data = {
          id: _id,
          approve: true,
          type: "join"

        }
        await apiSetNotification_approve(_data);
        if (state.page == page_max.value) {
          state.page--
        }
        getAPINotificationsData(state.page);
      }
      catch (err) {
        console.log("apiSetNotification_approve", 'err')
      }
    }
    const delete_click = async (e) => {
      try {
        var _data = {
          id: [
            e
          ],
          approve: false,
          type: "join"

        }
        await apiSetNotification_approve(_data);
        if (state.list_data.length - 1 <= 0) {
          state.page--
          if (state.page <= 1) {
            state.page = 1
          }
        }
        getAPINotificationsData(state.page);
      }
      catch (err) {
        console.log("apiSetNotification_approve", 'err')
      }
    }
    const delete_click_all = async () => {
      try {
        var _id = [];
        state.list_data.forEach(element => _id.push(element.approve_id));
        var _data = {
          id: _id,
          approve: false,
          type: "join"

        }
        apiSetNotification_approve
        await apiSetNotification_approve(_data);
        if (state.page == page_max.value) {
          state.page--
        }
        getAPINotificationsData(state.page);
      }
      catch (err) {
        console.log("apiSetNotification_approve", 'err')
      }
    }
    const store = useStore();
    const storeState = store.state;
    const showModalGlobal = () => {
      const modalConfig = {
        type: POPUP.DEMO,
        data: ['AAAA', 'BBB', 'CCCC'],
        isShow: true,
      }
      store.commit('setIsShowModal', modalConfig)
    }
    const details = async (e) => {
      console.log('?????', e)
      try {
        const data = await apiGetTasks(e);
        console.log('Tasks api data', data);
        state.deviceListData = data.tasks;
        for (let i = 0; i < state.deviceListData.length; i++) {
          state.deviceListData[i].newStatus = null
          if (state.deviceListData[i].deleted) {
            state.deviceListData[i].newStatus = 4
          } else if (state.deviceListData[i].status == 0) {
            state.deviceListData[i].newStatus = 999
          } else {
            state.deviceListData[i].newStatus = state.deviceListData[i].status
          }
        }
        console.log('Tasks state.deviceListData', state.deviceListData);
        const modalConfig = {
          type: POPUP.DETAILS,
          data: {
            id: e,
            group_name: data.group_name,
            profile_name: data.profile_name,
            deviceListCol: deviceListCol,
            deviceListData: state.deviceListData,
          },
          isShow: true,
        }
        store.commit('setIsShowModal', modalConfig)
      }
      catch (err) {
        console.log("apiGetTasks", 'err')
      }
    }
    store.watch((state) => (state.isShowModal, state.modalType), (newType, oldType) => {
      // modal type
      if (oldType === POPUP.DETAILS) {
        console.log('toreState.modalBtnType', storeState.modalBtnType);
        // modal btn type
        if ((storeState.modalBtnType).indexOf(BTN.CONFIRM) > -1) {
          const output = storeState.modalOutput
          console.log(output);
        }
      } //end: modal
    })
    let interval = null;


    onMounted(() => {
      _init();
      interval = setInterval(() => {
        _init(false);
      }, storeState.updateTime);
      getAPINotificationsNew()
    })

    onUnmounted(() => {
      console.log('onUnmounted');
      clearInterval(interval);
    })

    const getAPINotificationsNew = async () => { //取得header的訊息總數
      try {
        const datas = await apiNotificationsCount();
        console.log('apiNotificationsCount', datas)
        let total = 0;
        if (!datas.status_code) {
          for (let key in datas) {
            if (key != "status_code" && key != "message") {
              // console.log(key,datas[key])
              total += datas[key]
            }
          }

          store.commit('setAlertNotification', total)
        }
      }
      catch (error) {
        return error;
      }
    }



    //$i18n
    watch(
      () => locale,
      () => {
        orgDBD()
      },
      { deep: true }
    )



    const orgDBD = () => {
      let _data = multiLang.initRawData;
      let _currentTheme = storeState.theme;
      let mainColor =  _currentTheme === THEME_OPT.PROART ? "#CDAC83" : "#006CE1";
      //#region Calibration
      state.Calibration = [
        {
          name: t('__d7d_n17r.__withinNumMonth', { num: '3' }),//@i18n
          id: "three_months",
          color: "#EBEBEB",
          amount: _data['calibration'].three_months
        },
        {
          name: t('__d7d_n17r.__withinNumMonth', { num: '3-6' }),//@i18n
          id: "six_months",
          color:mainColor,
          amount: _data['calibration'].six_months
        },
        {
          name: t('__d7d_n17r.__withinNumMonth', { num: '6-12' }),//@i18n
          id: "twelve_months",
          color: "#8c8e97",
          amount: _data['calibration'].twelve_months
        },
        {
          name: t('__d7d_n17r.__notYetOver1Year'),//@i18n
          id: "one_year",
          color: "#000000",
          amount: _data['calibration'].one_year
        },

      ];
      state.Connection = [
        {
          name: t('__d7d_n17r.__connected'),//@i18n
          id: "online",
          color: mainColor,
          amount: _data['connection'].online
        },
        {
          name: t('__d7d_n17r.__disconnected'),//@i18n
          id: "offline",
          color: "#000000",
          amount: _data['connection'].offline
        },
      ]
      //#endregion
      //#region line_chart
      state.line_chart_array = [];
      for (var a = 0; a < _data['ongoing_tasks'].length; a++) {
        var _line_chart_array = {
          id: _data['ongoing_tasks'][a].id,
          title: t('__d7d_n17r.__ongoingTask'), //@i18n
          model: _data['ongoing_tasks'][a].model,
          time: dateTimeHandle(_data['ongoing_tasks'][a].created_at),
          total: parseInt(_data['ongoing_tasks'][a].success) + parseInt(_data['ongoing_tasks'][a].fail) + parseInt(_data['ongoing_tasks'][a].wait),
          data: [
            {
              name: t('__common.__success'),//@i18n
              color: mainColor,
              value: parseInt(_data['ongoing_tasks'][a].success)
            },
            {
              name: t('__common.__fail'),//@i18n
              color: "#FF4B4B",
              value: parseInt(_data['ongoing_tasks'][a].fail)
            },
            {
              name: t('__common.__wait'),//@i18n
              color: "#000000",
              value: parseInt(_data['ongoing_tasks'][a].wait)
            },
          ]
        };
        state.line_chart_array.push(_line_chart_array);
      }
      if (_data['last_task']) {
        _line_chart_array = {
          id: _data['last_task'].id,
          title: t('__d7d_n17r.__lastCompletedTask'),//@i18n
          model: _data['last_task'].model,
          time: dateTimeHandle(_data['last_task'].created_at),
          total: parseInt(_data['last_task'].success) + parseInt(_data['last_task'].fail),
          data: [
            {
              name: t('__common.__success'),//@i18n
              color: mainColor,
              value: parseInt(_data['last_task'].success)
            },
            {
              name: t('__common.__fail'),//@i18n
              color: "#FF4B4B",
              value: parseInt(_data['last_task'].fail)
            },
          ]
        };
        state.line_chart_array.push(_line_chart_array);
      }
      //#endregion
      //#region Amount
    }


    // init data
    const _init = (isNeedLoading = true) => {
      let group = state.groups.val === 'All' ? {} : { group: state.groups.val };
      getAPIDashboardsData(group, isNeedLoading);
      getAPINotificationsData(state.page, isNeedLoading);
      getAPIGetGroupModel(isNeedLoading);
    }
    const getAPIDashboardsData = async (group, isNeedLoding = true) => {
      store.commit('setIsNeedLoading', isNeedLoding);
      try {
        const data = await apiGetDashboard(group);
        var _data = data.data;
        multiLang.initRawData = data.data
        // console.log('Dashboards api data', _data);

        orgDBD()
        state.value_R_1 = _data.appointment_count;
        state.value_R_2 = _data.task_executed_count;
        state.value_L_1 = _data.group_count;
        state.value_L_2 = _data.device_count;
        //#endregion
      }
      catch (err) {
        console.log("apiGetDashboard", 'err')
      }
    }
    const getAPINotificationsData = async (page, isNeedLoding = true) => {
      store.commit('setIsNeedLoading', isNeedLoding)
      try {
        var _post_data = {}
        if (state.group != "All") {
          _post_data = {
            per_page: 6,
            page: page,
            group: state.group
          }
        } else {
          _post_data = {
            per_page: 6,
            page: page
          }
        }
        const data = await apiGetNotifications(_post_data);
        // console.log('Notifications api data', data);
        let news = data.join_news + data.other_news + data.unbind_news + data.unlock_news;
        state.newNews = news ? true : false;
        state.list_number = data.total;
        state.list_data = [];
        for (var a = 0; a < data.data.length; a++) {
          var _list = {
            name: data.data[a].ssn,
            info: data.data[a].host,
            model: data.data[a].model,
            ip: data.data[a].ip,
            approve_id: data.data[a].device_id,
            delete_id: data.data[a].id,
          }
          state.list_data.push(_list);
        }
      }
      catch (err) {
        console.log("apiGetNotifications", 'err')
      }
    }
    const getAPIGetGroupModel = async (isNeedLoding = true) => {
      store.commit('setIsNeedLoading', isNeedLoding);
      try {
        const data = await apiGetGroupModel();
        // console.log('Group api data', data);
        state.groups_op = [
          {
            text: t('__d7d_n17r.__allDevices'),
            val: 'All',
            isI18n: '__d7d_n17r.__allDevices',
          },
        ]
        for (var a = 0; a < data.groups.length; a++) {
          var _g = {
            text: data.groups[a].name,
            val: data.groups[a].id
          }
          state.groups_op.push(_g);
        }
      }
      catch (err) {
        console.log("apiGetGroupModel", 'err')
      }
    }









    watch(
      () => state.groups, () => {
        // console.log(state.groups.val)
        var _g = state.groups.val;
        if (state.group != _g) {
          state.group = _g;
          var _group = {};
          if (_g != "All") {
            _group = {
              group: _g
            };
          }
          getAPIDashboardsData(_group);
          state.page = 1;
          getAPINotificationsData(state.page);
        }
      }
    )
    return {
      state,
      iconSrc,
      onClick,
      IsChecked,
      page_max,
      click_page,
      details,
      showModalGlobal,
      approve_click,
      delete_click,
      approve_click_all,
      delete_click_all,
      t,
      multiLang,
      orgDBD,
      deviceListCol,
      getAPINotificationsNew,
      hasFocus
    }
  }
}


